import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { DataCollectionRequestFileCount } from '@main/pc-types';

/**
 *data practices state
 */
export interface DataPracticesState {
  /** The data practices file counts info */
  dataCollectionsRequestFileCount: DataCollectionRequestFileCount[] | undefined;
}

export const dataPracticesSlice = createSlice({
  name: 'DataPractices',
  initialState: {
    dataCollectionsRequestFileCount: undefined,
  } as DataPracticesState,
  reducers: {
    setDataCollectionsRequestFileCount: (
      state,
      {
        payload: { dataCollectionsRequestFileCount },
      }: PayloadAction<{
        /** Data collections request file count info */
        dataCollectionsRequestFileCount: DataCollectionRequestFileCount[];
      }>,
    ) => {
      state.dataCollectionsRequestFileCount = dataCollectionsRequestFileCount;
    },
  },
});

export const { setDataCollectionsRequestFileCount } =
  dataPracticesSlice.actions;
